import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import CompletedIcon from 'img/green-checkmark@2X.png';
import IncompleteIcon from 'img/circle--jumbo@2x.png';

const SharedStatusIcon = observer(({shared}) => {
  return (
    shared ?
      <img className='mr1' src={CompletedIcon} width='10' alt='status'/> :
      <img className='mr1' src={IncompleteIcon} width='10' alt='status'/>
  );
});

const SharedWithReviewee = observer(({model}) => {
  return (
    <div>
      {model.reviews.map(review => {
        if (!review.isManagerReview) return null;

        return <p key={review.id}><SharedStatusIcon shared={!!review.sharedAt} /> {review.reviewer.name}</p>
      })}
    </div>
  );
});

export default SharedWithReviewee;
